export enum AccessTypesEnum {
  canAnswer = 'canAnswer',
  canDownload = 'canDownload',
  canEdit = 'canEdit',
  canMonitor = 'canMonitor',
  canManageCourses = 'canManageCourses',
}
